import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8ea6639a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8ea6639a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea6639a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ea6639a')) {
      api.createRecord('8ea6639a', component.options)
    } else {
      api.reload('8ea6639a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8ea6639a&scoped=true", function () {
      api.rerender('8ea6639a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/task/index.vue"
export default component.exports